import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { AnyARecord } from "dns";
import { ConfirmationService, MessageService } from "primeng/api";
import { element } from "protractor";
import { ApiService } from "src/app/api.service";
import { Item } from "src/app/shared/models/Item";
import { ItemsAlbum } from "src/app/shared/models/ItemsAlbum";
import { ItemsTrack } from "src/app/shared/models/ItemsTrack";
import { OntexParameter } from "src/app/shared/models/OntexParameter";
import { ResponseFile } from "src/app/shared/models/ResponseFile";
import { SecurityDocument } from "src/app/shared/models/SecurityDocument";
import { Constants } from "src/app/shared/vo/Constants";
import { TovpilLanguageService } from "src/app/utils/tovpil-language.service";
import { TovpilUtilsService } from "src/app/utils/tovpil-utils.service";

@Component({
  selector: "app-items-track-dwn",
  templateUrl: "./items-track-dwn.component.html",
  styleUrls: ["./items-track-dwn.component.scss"],
  providers: [MessageService, ConfirmationService],
})
export class ItemsTrackDwnComponent implements OnInit {
  /** LABELS */
  translations: Record<string, string> = {};

  someSubscription: any;
  folderId: string = "DIGITALITEMS";
  itemId: string;
  albumId: string;
  token: string;
  itemDialog: boolean;
  itemDialogTrack: boolean;
  lstItemsTrak: ItemsTrack[];
  copyItemsTrak: ItemsTrack[];
  itemsAlbum: ItemsAlbum;
  selectedItemsTrak: ItemsTrack = null;
  item: Item = null;
  security: SecurityDocument;
  responseFile?: ResponseFile;
  sequence: string;
  dnwGroup: string;
  name: string;
  duration: string;
  length: string;
  status: string;
  fileName: string;
  imageSrc: string = "";
  showInternatColumns: boolean;
  selLang: string;
  dataParent: any;
  passKey: string;
  message: string;
  blocked: boolean = true;
  brasilConf: boolean = false;
  portugueseCountries: any[] = [
    { value: "Todos", consultVal: "T" },
    { value: "Portugal", consultVal: "" },
    { value: "Brasil", consultVal: "BR" },
  ];

  selectedCountry: any = this.portugueseCountries[0];
  selectedRegion: any = this.portugueseCountries[0];

  mapReadyItems = new Map();
  ctSongs = 0;

  playlist = [{ name: "music1", play: false }];

  // Redirect to album
  itemIdAlbum: string;
  dnwGroupAlbum: string;
  tokenAlbum: string;
  languageAlbum: string;
  device: string;

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService,
    private translationService: TovpilLanguageService
  ) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.queryParams as any;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.someSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Here is the dashing line comes in the picture.
        // You need to tell the router that, you didn't visit or load the page previously, so mark the navigated flag to false as below.
        this.router.navigated = false;
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.itemIdAlbum = params.itemIdAlbum;
      this.dnwGroupAlbum = params.dnwGroupAlbum;
      this.tokenAlbum = params.tokenAlbum;
      this.languageAlbum = params.languageAlbum;
      this.device = params.device;

      this.itemId = params.itemId;
      this.albumId = params.albumId;
      this.token = params.token;
      this.dnwGroup = params.dnwGroup;
      this.selLang = params.language;
      this.passKey = params.passKey;
    });

    Constants.mapPlayList = new Map();

    this.showInternatColumns = false;
    if (this.passKey) {
      this.findPurchItmDwnByPassKey();
    } else {
      this.getSecurity();
    }
  }
  ngOnDestroy() {
    if (this.someSubscription) {
      this.someSubscription.unsubscribe();
    }
  }

  async getSecurity() {
    const data = await this.apiService.findSecurityById({ id: this.token });
    this.security = data;
    if (this.security) {
      this.getTranslatedLabels();
      if (
        this.security.levelId == "I" &&
        (this.security.functionId == "secre" ||
          this.security.functionId == "coord" ||
          this.security.functionId == "treas" ||
          this.security.functionId == "mate" ||
          this.security.userId == "administrador")
      ) {
        this.showInternatColumns = true;
      }
      await this.listItemsTrackByItemAlbum();
      await this.getItemsAlbumById();
    }
  }

  // No es necesario agregar region, se puede sacar con guideId
  async listItemsTrackByItemAlbum() {
    this.lstItemsTrak = [];
    const data = await this.apiService.listItemsTrackByItemAlbum({
      itemId: this.itemId,
      albumId: this.albumId,
      language: this.selLang,
      guideId: this.security.guideId,
    });
    this.lstItemsTrak = data;
    this.copyItemsTrak = this.lstItemsTrak;
    this.message = "loading ... 1 / " + this.lstItemsTrak.length;
    await this.getItemById();
  }
  openNew() {
    this.sequence = null;
    this.name = null;
    this.fileName = null;
    this.duration = null;
    this.length = null;
    this.status = null;
    this.selectedItemsTrak = null;
    this.itemDialog = true;
  }

  hideDialog() {
    this.itemDialog = false;
    this.selectedItemsTrak = null;
    this.brasilConf = false;
    // this.listItemsTrackByItemAlbum();
  }

  eventCancel() {
    this.stopFile();
    window.close();
    this.router.navigate(["santov/listItemsAlbum"], {
      queryParams: {
        itemId: this.itemIdAlbum,
        token: this.tokenAlbum,
        dnwGroup: this.dnwGroupAlbum,
        language: this.languageAlbum,
        device: this.device,
      },
    });
  }

  async createUpdateTrack() {
    let savedItmTrack: ItemsTrack;
    if (!this.imageSrc) {
      this.messageService.add({
        severity: "error",
        summary: "ERROR:  ",
        detail: "cargue/suba audio MP3",
        life: 10000,
      });
    } else {
      if (
        this.fileName == null &&
        this.selectedItemsTrak != null &&
        this.selectedItemsTrak.fileName != null
      ) {
        this.fileName = this.selectedItemsTrak.fileName;
      }
      if (
        this.selectedItemsTrak == null ||
        this.selectedItemsTrak.id.sequence == null
      ) {
        try {
          let data = await this.apiService.createItemsTrack({
            id: {
              itemId: this.itemId,
              albumId: this.albumId,
              language: this.selLang,
              region: this.selectedRegion.consultVal == "BR" ? "BR" : "_",
              sequence: this.sequence,
            },
            name: this.name,
            duration: this.duration,
            length: this.length,
            status: "N",
            fileName: this.fileName,
          });
          console.debug("Se creará");
          savedItmTrack = data;
          this.saveFileToDisk(savedItmTrack.id.sequence);
          this.hideDialog();
          this.listItemsTrackByItemAlbum();
        } catch (error) {
          console.error("Error al crear item");
        }
      } else {
        try{
          let data = await this.apiService.updateItemsTrack({
            id: {
              itemId: this.itemId,
              albumId: this.albumId,
              language: this.selLang,
              region: this.selectedRegion.consultVal,
              sequence: this.selectedItemsTrak.id.sequence,
            },
            name: this.name,
            duration: this.duration,
            length: this.length,
            status: this.selectedItemsTrak.status,
            fileName: this.fileName,
          });
            console.debug("Se actualizará");
            savedItmTrack = data;
            this.saveFileToDisk(savedItmTrack.id.sequence);
            this.hideDialog();
        } catch(error){
          console.error("Error al actualizar item", error);
        }
      }
    }
  }

  //Function to edit a record
  edit(doc: ItemsTrack) {
    this.selectedItemsTrak = null;
    this.apiService
      .getItemsTrackById({
        itemId: doc.id.itemId,
        albumId: doc.id.albumId,
        language: doc.id.language,
        sequence: doc.id.sequence,
        region: doc.id.region,
      })
      .then((data) => {
        this.selectedItemsTrak = data;
        this.name = doc.name;
        this.sequence = doc.id.sequence;
        this.duration = doc.duration;
        this.length = doc.length;
        this.itemDialog = true;
        if (doc.id.region == "BR") {
          this.selectedRegion = this.portugueseCountries[2];
        } else {
          this.selectedRegion = this.portugueseCountries[0];
        }
      });
  }
  uploadFile(e) {
    this.imageSrc = "";
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    var pattern = /image-*/;
    var reader = new FileReader();
    this.fileName = file.name;

    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    let array = reader.result.split(",");
    this.imageSrc = array[1];
  }

  // AQUÍ NO SE NECESITA
  async getItemById() {
    try {
      const data = await this.apiService.getItemByIdLang({
        itemId: this.itemId,
        language: this.selLang,
      });
      this.item = data;
      this.getBase64File(this.lstItemsTrak);
    } catch (error) {
      console.error("Error en getItemId: ", error);
    }
  }

  async onClickDownloadFile(itm: ItemsTrack) {
    let nameFile = "";
    if (itm.id.region == "BR") {
      nameFile =
        itm.id.itemId +
        "_" +
        itm.id.albumId +
        "_" +
        itm.id.sequence +
        "_" +
        this.selLang +
        "_" +
        itm.id.region +
        "." +
        this.item.sellUM;
    } else {
      nameFile =
        itm.id.itemId +
        "_" +
        itm.id.albumId +
        "_" +
        itm.id.sequence +
        "_" +
        this.selLang +
        "." +
        this.item.sellUM;
    }

    try {
      let data = await this.apiService.getFileSantoApp({
        nameFile: nameFile,
        folderId: this.folderId,
      });
      this.responseFile = data;

      const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;

      const link = document.createElement("a");
      link.href = source;
      link.download = `${
        (this.item != null ? this.item.descri : "") +
        "_" +
        (this.itemsAlbum != null ? this.itemsAlbum.name : "") +
        "_" +
        itm.id.sequence +
        " " +
        itm.name +
        "." +
        this.item.sellUM
      }`;
      link.click();
    } catch (error) {
      console.error("Error en onClickDownloadFile: ", error);
    }
  }

  async onClickApprove(itm: ItemsTrack) {
    try {
      await this.apiService.updateItemsTrack({
        id: {
          itemId: itm.id.itemId,
          albumId: itm.id.albumId,
          language: itm.id.language,
          region: itm.id.region,
          sequence: itm.id.sequence,
        },
        name: itm.name,
        fileName: itm.fileName,
        duration: itm.duration,
        length: itm.length,
        status: "A",
      });
      this.hideDialog();
      this.listItemsTrackByItemAlbum();
    } catch (error) {
      console.error("Eror on onClickApprove: ", error);
    }
  }

  disabledEditRules(itm: ItemsTrack) {
    let result: boolean = true;
    if (itm.fileName == null || itm.status != "A") {
      result = false;
    }
    return result;
  }

  //Hay que agregar la region
  async getItemsAlbumById() {
    const data = await this.apiService.getItemsAlbumById({
      itemId: this.itemId,
      albumId: this.albumId,
      language: this.selLang,
    });
    this.itemsAlbum = data;
  }

  checkDisabedDownload(doc: ItemsTrack) {
    let result = true;
    if (this.showInternatColumns) {
      result = false;
    } else {
      if (doc.status == "A" && doc.fileName != null) {
        result = false;
      }
    }
    return result;
  }

  async saveFileToDisk(seq: string) {
    if (this.imageSrc != null) {
      let nameFile;
      if (this.selectedRegion.consultVal == "BR") {
        nameFile =
          this.itemId +
          "_" +
          this.albumId +
          "_" +
          seq +
          "_" +
          this.selLang +
          "_BR" +
          "." +
          this.item.sellUM;
      } else {
        nameFile =
          this.itemId +
          "_" +
          this.albumId +
          "_" +
          seq +
          "_" +
          this.selLang +
          "." +
          this.item.sellUM;
      }

      try {
        const data = await this.apiService.saveFileSantoApp({
          nameFile: nameFile,
          base64File: this.imageSrc,
          folderId: this.folderId,
        });
        if (!data) {
          if (this.selectedRegion.consultVal == "BR") {
            Constants.mapPlayList.set(
              this.itemId +
                "_" +
                this.albumId +
                "_" +
                seq +
                "_" +
                this.selLang +
                "_BR" +
                "." +
                this.item.sellUM,
              data.base64File
            );
          } else {
            Constants.mapPlayList.set(
              this.itemId +
                "_" +
                this.albumId +
                "_" +
                seq +
                "_" +
                this.selLang +
                "." +
                this.item.sellUM,
              data.base64File
            );
          }
        }
        this.imageSrc = null;
      } catch (error) {
        console.error("Error en saveFileToDisk: ", error);
      }
    }
  }
  /**
   * The function `getTranslatedLabels` asynchronously retrieves translated labels based on user
   * preferences and handles any errors that occur.
   */
  async getTranslatedLabels() {
    const language = this.security.language || null;
    const region = this.security.region || null;
    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.translations.lbl_translation} ${this.translations.translations.lbl_language}` });
    }
  }

  onClickPlayFile(itm: ItemsTrack) {
    if (Constants.playingTrack) {
      let newTrack = "";
      if (itm.id.region == "BR") {
        newTrack =
          itm.id.itemId +
          "_" +
          itm.id.albumId +
          "_" +
          itm.id.sequence +
          "_" +
          this.selLang +
          "_BR" +
          "." +
          this.item.sellUM;
      } else {
        newTrack =
          itm.id.itemId +
          "_" +
          itm.id.albumId +
          "_" +
          itm.id.sequence +
          "_" +
          this.selLang +
          "." +
          this.item.sellUM;
      }
      if (newTrack != Constants.playingTrack) {
        this.stopFile();
        Constants.playingTrack = newTrack;
        this.playFile();
      } else {
        this.stopFile();
      }
    } else {
      if (itm.id.region == "BR") {
        Constants.playingTrack =
          itm.id.itemId +
          "_" +
          itm.id.albumId +
          "_" +
          itm.id.sequence +
          "_" +
          this.selLang +
          "_BR" +
          "." +
          this.item.sellUM;
      } else {
        Constants.playingTrack =
          itm.id.itemId +
          "_" +
          itm.id.albumId +
          "_" +
          itm.id.sequence +
          "_" +
          this.selLang +
          "." +
          this.item.sellUM;
      }
      this.playFile();
    }
  }

  playFile() {
    this.message =
      "Now Playing: " + this.mapReadyItems.get(Constants.playingTrack);
    Constants.sound = new Audio(
      "data:audio/MP3;base64," +
        Constants.mapPlayList.get(Constants.playingTrack)
    );
    Constants.sound.controls = true;
    Constants.sound.play();
  }

  stopFile() {
    this.message = "";
    if (Constants.playingTrack && Constants.sound) {
      let base64 = Constants.mapPlayList.get(Constants.playingTrack);
      if (base64) {
        Constants.sound.pause();
        Constants.sound.currentTime = 0;
        Constants.playingTrack = null;
      }
    } else if (!Constants.sound) {
      Constants.sound = new Audio(
        "data:audio/mp3;base64," +
          Constants.mapPlayList.get(
            this.itemId +
              this.albumId +
              "001" +
              "_" +
              this.selLang +
              "." +
              this.item.sellUM
          )
      );
      Constants.sound.pause();
      Constants.sound.currentTime = 0;
      Constants.playingTrack = null;
      Constants.sound = null;
    }
  }

  async getBase64File(data: ItemsTrack[]) {
    if (data.length == null || data.length == 0) {
      setTimeout(() => {
        this.blocked = false;
      }, 1500);
    }
    data.forEach(async (element) => {
      if (element.fileName) {
        let nameFile = "";
        if (element.id.region == "BR") {
          nameFile =
            this.itemId +
            "_" +
            this.albumId +
            "_" +
            element.id.sequence +
            "_" +
            this.selLang +
            "_BR" +
            "." +
            this.item.sellUM;
        } else {
          nameFile =
            this.itemId +
            "_" +
            this.albumId +
            "_" +
            element.id.sequence +
            "_" +
            this.selLang +
            "." +
            this.item.sellUM;
        }

        console.log(nameFile);
        await this.apiService
          .getFileBinSantoApp({
            nameFile: nameFile,
            folderId: this.folderId,
          })
          .then((resp) => {
            this.ctSongs = this.ctSongs + 1;
            if (this.ctSongs == this.lstItemsTrak.length) {
              this.message = "List ready to play... DON NOT CLOSE THIS WINDOW";
              setTimeout(() => {
                this.blocked = false;
              }, 1500);
            } else {
              this.message =
                this.translations.lbl_loading +
                " " +
                (this.ctSongs + 1) +
                " / " +
                this.lstItemsTrak.length;
            }
            var reader = new FileReader();
            reader.readAsDataURL(resp);
            let self = Constants;
            reader.onloadend = function () {
              let array = (<string>reader.result).split(",");
              var base64data = array[1];
              self.mapPlayList.set(nameFile, array[1]);
              console.log(array);
            };
            for (let ct = 0; ct < this.lstItemsTrak.length; ct++) {
              if (this.lstItemsTrak[ct].id.sequence == element.id.sequence && this.lstItemsTrak[ct].id.region == element.id.region) {
                this.lstItemsTrak[ct].readyToPlay = "READY";
                this.mapReadyItems.set(nameFile, element.name);
              }
            }
          })
          .catch((error) => {
            console.error(error);
            this.ctSongs = this.ctSongs + 1;
            if (this.ctSongs == this.lstItemsTrak.length) {
              this.message = "List ready to play... DON NOT CLOSE THIS WINDOW";
              setTimeout(() => {
                this.blocked = false;
              }, 1500);
            }
          })
          .finally(() => {
            setTimeout(() => {
              this.blocked = false;
            }, 1500);
          });
      }
    });
  }

  returnConfirm() {
    //Confirm
    this.confirmationService.confirm({
      message: this.translations.lbl_wish_to_continue,
      header:
        this.translations.lbl_confirm +
        " " +
        this.translations.lbl_exit.toUpperCase(),
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        // do accept action
        this.eventCancel();
        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      },
    });
  }

  async findPurchItmDwnByPassKey() {
    try {
      const data = await this.apiService.findPurchItmDwnByPassKey({
        id: this.passKey,
        language: this.selLang,
      });
      if (data) {
        this.itemId = data.purchItmDwn.id.itemId;
        this.selLang = data.purchItmDwn.id.language;
        this.security = {};
        this.security.language = this.selLang;

        await this.getTranslatedLabels();
        await this.listItemsTrackByItemAlbum();
        await this.getItemsAlbumById();
      }
    } catch (error) {
      console.error("Error en findPurchItmDwnByPassKey: ", error);
    }
  }

  removeSelected(selItm: ItemsTrack) {
    this.confirmationService.confirm({
      message: this.translations.lbl_wish_to_continue,
      header:
        this.translations.lbl_confirm +
        " " +
        this.translations.lbl_delete_record +
        ": <" +
        selItm.name +
        ">",
      acceptLabel: this.translations.lbl_yes,
      rejectLabel: this.translations.lbl_no,
      acceptButtonStyleClass: "p-button-success",
      rejectButtonStyleClass: "p-button-danger",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        // do accept action
        this.doremove(selItm);
        //
      },
      reject: (type) => {
        switch (type) {
          default:
            break;
        }
      },
    });
  }

  async doremove(selItm: ItemsTrack) {
    try {
      await this.apiService.deleteItemsTrack({
        id: {
          itemId: selItm.id.itemId,
          albumId: selItm.id.albumId,
          region: selItm.id.region,
          language: selItm.id.language,
          sequence: selItm.id.sequence,
        },
        name: selItm.name,
        fileName: selItm.fileName,
        duration: selItm.duration,
        length: selItm.length,
        status: selItm.status,
      });
      this.listItemsTrackByItemAlbum();
    } catch (error) {
      console.error("Error en doremove: ", error);
    }
  }

  async moveUp(selItm: ItemsTrack) {
    try {
      this.apiService.moveItemsTrack({
        id: {
          itemId: selItm.id.itemId,
          albumId: selItm.id.albumId,
          region: selItm.id.region,
          language: selItm.id.language,
          sequence: selItm.id.sequence,
        },
        orderToPlay: "up",
      });
      this.listItemsTrackByItemAlbum();
    } catch (error) {
      console.error("Error en moveUp: ", error);
    }
  }

  async moveDown(selItm: ItemsTrack) {
    try {
      await this.apiService.moveItemsTrack({
        id: {
          itemId: selItm.id.itemId,
          albumId: selItm.id.albumId,
          region: selItm.id.region,
          language: selItm.id.language,
          sequence: selItm.id.sequence,
        },
        orderToPlay: "down",
      });
      this.listItemsTrackByItemAlbum();
    } catch (error) {
      console.error("Error en moveDown: ", error);
    }
  }

  onChangeCountryPT() {
    this.selectedRegion = this.selectedCountry;
    // LLamada a la api para traer los items que deben ser
    if (this.selectedRegion.consultVal != "T") {
      if (this.selectedRegion.consultVal == "") {
        this.lstItemsTrak = this.copyItemsTrak.filter((e) => {
          return e.id.region == "_";
        });
      } else if (this.selectedRegion.consultVal == "BR") {
        this.lstItemsTrak = this.copyItemsTrak.filter((e) => {
          return e.id.region == "BR";
        });
      }
    } else {
      this.lstItemsTrak = this.copyItemsTrak;
    }
  }

  createBrazilRecord(value: ItemsTrack) {
    this.brasilConf = true;
    this.itemDialog = true;
    this.sequence = value.id.sequence;
    this.name = value.name;
    this.selectedRegion = this.portugueseCountries[2];
  }
}
